import { createSlice } from "@reduxjs/toolkit";

const getSavedDynamicTabs = () => {
  try {
    const savedTabs = sessionStorage.getItem("dynamicTabs");

    if (savedTabs) {
      return JSON.parse(savedTabs);
    }
  } catch (error) {
    console.error("Unable to restore dynamic tabs:", error);
  }

  return [{ title: "Dashboard", link: "/home" }];
};

const initialState = {
  user_data: {},
  user_name: "",
  user_img: "",
  DynamicTab: getSavedDynamicTabs(),
  wigitArr: 0,
  isProdDB: true,
  userAccessData: [],
};

const slice = createSlice({
  name: "HomePageReducer",
  initialState,
  reducers: {
    set_user_data(state, action) {
      state.user_data = action.payload;
    },
    set_user_name(state, action) {
      state.user_name = action.payload;
    },
    set_user_img(state, action) {
      state.user_img = action.payload;
    },
    setDynamicTab(state, action) {
      if (!state.DynamicTab.some((obj) => obj?.link === action.payload.link)) {
        state.DynamicTab = [...state.DynamicTab, action.payload];
      }
    },
    updatedynamicTab(state, action) {
      state.DynamicTab = action.payload;
    },
    removeDynamicTab(state, action) {
      state.DynamicTab = state.DynamicTab.filter((item) => item.link !== action.payload);
    },
    setwigitArr(state, action) {
      state.wigitArr = action.payload;
    },
    setIsProdDB(state, action) {
      state.isProdDB = action.payload;
    },
    setUserAccessData(state, action) {
      state.userAccessData = action.payload;
    },
    resetDynamicTabs(state, action) {
      state.DynamicTab = [{ title: "Dashboard", link: "/home" }];
    },
  },
});

export const {
  set_user_data,
  set_user_name,
  set_user_img,
  setDynamicTab,
  removeDynamicTab,
  Resetfilter,
  setwigitArr,
  updatedynamicTab,
  setIsProdDB,
  setUserAccessData,
  resetDynamicTabs,
} = slice.actions;

export default slice.reducer;
